import { render, staticRenderFns } from "./UserResetPasswordRequest.vue?vue&type=template&id=4a9ba9f2"
import script from "./UserResetPasswordRequest.vue?vue&type=script&lang=ts"
export * from "./UserResetPasswordRequest.vue?vue&type=script&lang=ts"
import style0 from "./UserResetPasswordRequest.vue?vue&type=style&index=0&id=4a9ba9f2&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports